<ng-container *ngIf="validationErrors">
  <h1>Validációs hibák</h1>
  <ul>
    <li *ngFor="let error of validationErrors.errors | keyvalue">
      <span class="error-key">{{ error.key }}</span>
      <ul>
        <li *ngFor="let message of error.value">{{ message }}</li>
      </ul>
    </li>
  </ul>
</ng-container>
